// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_58-2";
export var blackBorderOnHover = "_58-7";
export var cell = "_58-6";
export var cellContainer = "_58-3";
export var checked = "_58-8";
export var disabled = "_58-5";
export var featuredIconCellContainer = "_58-9";
export var featuredIconTextContainer = "_58-b";
export var featuredIconWrapper = "_58-a";
export var noBorder = "_58-c";
export var orangeSelectedRow = "_cx-3";
export var overflowableText = "_58-0";
export var overflowableTextContainer = "_58-1";
export var row = "_5b-0";
export var rowCheckboxCell = "_58-4";
export var selectableTable = "_cx-2";